<template>
  <div class="grid grid-cols-1 gap-6">
    <div class="flex justify-between items-center">
      <div>
        <vs-select class="w-full mr-auto" autocomplete v-model="filter.field_id" @change="updateSeriesData">
          <vs-select-item v-for="(item, index) in fieldList" :key="index" :text="item.field_name" :value="item.field_id" />
        </vs-select>
      </div>
      <div class="flex gap-2">
        <vs-button color="secondary" type="border" @click="onBackClick">목록</vs-button>
      </div>
    </div>
    <v-bar-chart-card
      title="위험성평가 현황"
      use-select-year
      :series="series"
      :colors="['#7E72F2', '#F99600', '#333333']"
      :categories="categories"
      total-label="실시총계"
      count-label="중요위험"
      :category-counts="categoryCounts"
      @select:year="onClickYear"
      :loading="isLoading"
    >
      <template #header="{ isMobile, categoryCounts }">
        <div class="mb-1">
          <span class="font-medium" style="display: inline-block; width:80px; text-align: right">전체 팀:</span>
          실시율 {{ totalCount.공정분류 === 0 ? 0.00 :(totalCount.실시건 / totalCount.공정분류 * 100).toFixed(2) }}%,
          중요위험 개선율 {{ (totalCount.개선전 + totalCount.종결) === 0 ? 0.00 :(totalCount.종결 / (totalCount.개선전 + totalCount.종결) * 100).toFixed(2) }}%
        </div>
        <div class="mb-2">
          <span class="font-medium" style="display: inline-block; width:80px; text-align: right">상위 4개 팀:</span>
          실시율 {{ series_totalCount.공정분류 === 0 ? 0.00 :(series_totalCount.실시건 / series_totalCount.공정분류 * 100).toFixed(2) }}%,
          중요위험 개선율 {{ (series_totalCount.개선전 + series_totalCount.종결) === 0 ? 0.00 :(series_totalCount.종결 / (series_totalCount.개선전 + series_totalCount.종결) * 100).toFixed(2) }}%
        </div>
      </template>
      <template #right-buttons>
        <span class="btn-border py-1 px-2" :class="chartType === 'all' && 'active'" @click="onChangeChartType('all')">전체</span>
        <span class="btn-border py-1 px-2" :class="chartType === '직영' && 'active'" @click="onChangeChartType('직영')">직영</span>
        <span class="btn-border py-1 px-2" :class="chartType === '수급업체' && 'active'" @click="onChangeChartType('수급업체')">수급업체</span>
      </template>
    </v-bar-chart-card>

    <div class="flex justify-end">
      <vs-button color="secondary" type="border" @click="onClickExcelDownload" > Excel 다운로드 </vs-button>
    </div>

    <vs-table
      class="w-full mb-4"
      noDataText="검색된 현장이 없습니다"
      ref="table"
      stripe
      :data="tableList"
      :sst="true"
      :max-items="pagination.perPage"
      color="success"
    >

      <template slot="thead">
        <vs-th style="min-width:80px; max-width: 80px;"><span class="w-full text-center">No.</span></vs-th>
        <vs-th><span class="w-full text-center">사업장</span></vs-th>
        <vs-th><span class="w-full text-center">팀명</span></vs-th>
        <vs-th><span class="w-full text-center">공정분류 (평가대상)</span></vs-th>
        <vs-th><span class="w-full text-center">실시 건</span></vs-th>
        <vs-th><span class="w-full text-center">실시율(%)</span></vs-th>
        <vs-th><span class="w-full text-center">중요위험 대상</span></vs-th>
        <vs-th><span class="w-full text-center">중요위험 (개선 전)</span></vs-th>
        <vs-th><span class="w-full text-center">중요위험 (종결)</span></vs-th>
        <vs-th><span class="w-full text-center">개선율(%)</span></vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr class="text-center" :data="item" :key="index" v-for="(item, index) in data">
          <vs-td>{{ ((pagination.page - 1) * pagination.perPage) + index +1 }}</vs-td>
          <vs-td>{{ item['사업장'] }}</vs-td>
          <vs-td>{{ item['팀명'] }}</vs-td>
          <vs-td>{{ item['공정분류'] }}</vs-td>
          <vs-td>{{ item['실시건'] }}</vs-td>
          <vs-td>{{ item['실시율'] }}</vs-td>
          <vs-td>{{ item['중요위험대상'] }}</vs-td>
          <vs-td>{{ item['개선전'] }}</vs-td>
          <vs-td>{{ item['종결'] }}</vs-td>
          <vs-td>{{ item['개선율'] }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="vs-con-table">
      <div class="con-pagination-table vs-table--pagination">
        <k-pagination :total="Math.floor(tableListAll.length / pagination.perPage) + 1" v-model="pagination.page"></k-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import VBarChartCard from "@/components/chart/VBarChartCard.vue";
import KPagination from "@/components/kPagination/kPagination.vue";
import idb from "@/util/IndexDbUtil";
import XLSX from "xlsx";

export default {
  name: 'VBarChart306',
  components: { KPagination, VBarChartCard},
  computed: {
    fieldList() {
      const orderBy = ["본사", "인천공장", "포항공장", "당진공장", "중앙기술연구소"]
      const list = this.$store.state.project.fieldListInfo.data
      if (!list || list.length === 0) return []
      return [
        {
          field_id: 0,
          field_name: "전체"
        },
        ...list.map(field => {
          return {
            field_id: field.id,
            field_name: field.field_name
          }
        }).sort((a, b) => {
          const indexA = orderBy.indexOf(a.field_name);
          const indexB = orderBy.indexOf(b.field_name);
          return indexA - indexB;
        })
      ];
    },
    projectId () {
      return this.$route.params.proj_id
    },

    // 현재 선택된 사업장의 데이터
    currentFieldData() {
      if (!this.apiResponse) return null;

      if (this.filter.field_id === 0) {
        // 전체 선택 시
        return {
          series: this.apiResponse.series,
          categories: this.apiResponse.categories,
          categoryCounts: this.apiResponse.categoryCounts,
          공정분류_평가대상: this.apiResponse.공정분류_평가대상
        };
      }

      // 특정 사업장 선택 시 (field_id가 빈 값인 데이터는 제외)
      const fieldData = this.apiResponse.사업장별_집계.find(
        item => item.field_id && item.field_id === this.filter.field_id
      );

      return fieldData || null;
    },

    // 테이블용 전체 팀 목록
    tableListAll() {
      if (!this.currentFieldData) return [];

      const categories = this.currentFieldData.categories;
      const 공정분류Data = this.currentFieldData.공정분류_평가대상 || {};

      // series에서 각 팀별 데이터 추출
      const 실시건Series = this.currentFieldData.series.find(s => s.name === "실시 건");
      const 개선전Series = this.currentFieldData.series.find(s => s.name === "중요위험(개선 전)");
      const 종결Series = this.currentFieldData.series.find(s => s.name === "중요위험(종결)");

      return categories.map((팀명, index) => {
        const 중요위험대상 = (개선전Series && 종결Series && (개선전Series.data[index] + 종결Series.data[index])) || 0
        return {
          사업장: this.get사업장명withCategory(팀명),
          팀명,
          공정분류: 공정분류Data[팀명] || 0,
          실시건: (실시건Series && 실시건Series.data[index]) || 0,
          실시율: (실시건Series && 공정분류Data[팀명] > 0 && (Math.floor(실시건Series.data[index] / 공정분류Data[팀명] * 10000) / 100).toFixed(2) ) || '0.00',
          중요위험대상: 중요위험대상,
          개선전: (개선전Series && 개선전Series.data[index]) || 0,
          종결: (종결Series && 종결Series.data[index]) || 0,
          개선율: (종결Series && 중요위험대상 && (Math.floor(종결Series.data[index] / 중요위험대상 * 10000 ) / 100).toFixed(2) ) || '0.00'
        }
      }).sort((a, b) => b.실시건 - a.실시건);
    },

    tableList() {
      return this.tableListAll.slice(
        (this.pagination.page - 1) * this.pagination.perPage,
        this.pagination.page * this.pagination.perPage
      );
    },

    totalCount() {
      if (!this.tableListAll.length) {
        return {공정분류: 0, 실시건: 0, 개선전: 0, 종결: 0};
      }

      return {
        공정분류: this.tableListAll.reduce((sum, item) => sum + item.공정분류, 0),
        실시건: this.tableListAll.reduce((sum, item) => sum + item.실시건, 0),
        개선전: this.tableListAll.reduce((sum, item) => sum + item.개선전, 0),
        종결: this.tableListAll.reduce((sum, item) => sum + item.종결, 0),
      };
    },

    series_totalCount() {
      if (!this.series[0] || !this.series[0].data || !this.series[0].data.length) {
        return {공정분류: 0, 실시건: 0, 개선전: 0, 종결: 0};
      }

      return {
        공정분류: this.series[0].data.reduce((sum, val) => sum + val, 0),
        실시건: this.series[1].data.reduce((sum, val) => sum + val, 0),
        개선전: this.series[2].data.reduce((sum, val) => sum + val, 0),
        종결: this.series[3].data.reduce((sum, val) => sum + val, 0),
      };
    },

    categoryCounts() {
      if (!this.currentFieldData) return [];
      return this.currentFieldData.categoryCounts || [];
    },

    // 캐시 키 생성
    cacheKey() {
      return `graph-detail-306-series-0-${this.year}-${this.chartType}-${this.projectId || 'all'}`;
    }
  },
  data () {
    return {
      graphId: 306,
      series: [
        { name: "공정분류(평가대상)", data: [], group: "single" }, // 단독 막대
        { name: "실시 건", data: [], group: "single" }, // 단독 막대
        { name: "중요위험(개선 전)", data: [], group: "group" }, // 스택 그룹
        { name: "중요위험(종결)", data: [], group: "group" }, // 스택 그룹
      ],
      categories: [],
      //------------
      year: new Date().getFullYear(), // 평가일자 년도
      isLoading: false, // 로딩 상태
      cacheExpiry: 60 * 1000, // 캐시 만료 시간 (1분)
      chartType: 'all', // 전체
      apiResponse: null, // 전체 API 응답 저장

      filter: {
        field_id: 0,
      },
      pagination: {
        page: 1,
        perPage: 10,
      }
    }
  },
  async mounted () {
    if (!this.$store.state.project.fieldListInfo.data) {
      await this.loadFieldList();
    }
    await this.loadList();
  },
  methods: {
    get사업장명withCategory(category) {
      let 사업장명 = "";
      this.apiResponse["사업장별_집계"].map(field => {
        if (field.categories.indexOf(category) > -1) {
          사업장명 = field.field_name;
        }
      })
      return 사업장명;
    },

    async loadFieldList() {
      const projectId = this.projectId;
      const page = 1;
      const perPage = 10;
      return await this.$store.dispatch("project/LOAD_FIELD_LIST", { projectId, page, perPage, showAll: 1 });
    },
    onClickDetail() {
      const projectId = this.$route.params.proj_id;
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph/306`);
      } else {
        this.$router.push(`/project/2/graph/306`);
      }
    },
    async loadList() {
      this.isLoading = true;
      this.pagination.page = 1;

      try {
        // IndexedDB 캐시 확인
        const cachedData = await this.checkCache();
        if (cachedData) {
          this.apiResponse = cachedData;
          this.updateSeriesFromFilter();

          setTimeout(() => {
            this.isLoading = false;
          }, 300);
          return;
        }

        // API 호출 (한 번만)
        const chartTypeMap = {
          'all': 'all',
          '직영': '직영',
          '수급업체': '수급'
        };

        const response = await this.$store.dispatch('summary/LOAD_VBAR_813_814_TEAM_DETAIL', {
          year: this.year,
          chartType: chartTypeMap[this.chartType],
          projectId: this.projectId
        });

        // 전체 응답 저장
        this.apiResponse = response;

        // IndexedDB 캐시 저장
        await this.saveCache(response);

        // 현재 필터에 맞게 series 업데이트
        this.updateSeriesFromFilter();

      } catch (error) {
        console.error('데이터 로드 중 오류 발생:', error);
      } finally {
        this.isLoading = false;
      }
    },

    // 필터 변경 시 series 업데이트 (API 재호출 없이)
    updateSeriesFromFilter() {
      if (!this.currentFieldData) return;

      const categories = this.currentFieldData.categories;

      // series 이름별로 찾기
      const 공정분류Series = this.currentFieldData.series.find(s => s.name === "공정분류(평가대상)");
      const 실시건Series = this.currentFieldData.series.find(s => s.name === "실시 건");
      const 개선전Series = this.currentFieldData.series.find(s => s.name === "중요위험(개선 전)");
      const 종결Series = this.currentFieldData.series.find(s => s.name === "중요위험(종결)");

      // 공정분류_평가대상이 객체인 경우와 배열인 경우 처리
      let 공정분류Data = this.currentFieldData.공정분류_평가대상;

      // 배열이거나 없는 경우 series 데이터에서 직접 가져오기
      if (Array.isArray(공정분류Data) || !공정분류Data) {
        공정분류Data = {};
        if (공정분류Series && 공정분류Series.data) {
          categories.forEach((팀명, index) => {
            공정분류Data[팀명] = 공정분류Series.data[index] || 0;
          });
        }
      }

      // 공정분류(평가대상) 기준으로 상위 4개 팀 선정
      const topTeams = categories
        .map((팀명, index) => ({
          팀명,
          index,
          공정분류: 공정분류Data[팀명] || 0
        }))
        .sort((a, b) => b.공정분류 - a.공정분류)
        .slice(0, 4);

      const topCategories = topTeams.map(t => t.팀명);
      const topIndices = topTeams.map(t => t.index);

      this.categories = topCategories;

      this.series = [
        {
          name: "공정분류(평가대상)",
          data: topIndices.map(idx => (공정분류Series && 공정분류Series.data[idx]) || 0),
          group: "single"
        },
        {
          name: "실시 건",
          data: topIndices.map(idx => (실시건Series && 실시건Series.data[idx]) || 0),
          group: "single"
        },
        {
          name: "중요위험(개선 전)",
          data: topIndices.map(idx => (개선전Series && 개선전Series.data[idx]) || 0),
          group: "group"
        },
        {
          name: "중요위험(종결)",
          data: topIndices.map(idx => (종결Series && 종결Series.data[idx]) || 0),
          group: "group"
        }
      ];
    },

    // 시리즈 데이터 업데이트 메서드
    updateSeriesData() {
      // 필터 변경 시 호출됨 (API 재호출 없이 캐시된 데이터 활용)
      this.pagination.page = 1;
      this.updateSeriesFromFilter();
    },

    async checkCache() {
      try {
        const cacheKey = this.cacheKey;
        const cachedData = await idb.getItem(cacheKey);
        return cachedData;
      } catch (error) {
        console.warn('캐시 확인 중 오류:', error);
        return null;
      }
    },

    async saveCache(data) {
      try {
        const cacheKey = this.cacheKey;
        await idb.setItem(cacheKey, data, this.cacheExpiry);
      } catch (error) {
        console.warn('캐시 저장 중 오류:', error);
      }
    },

    onClickYear(year) {
      if (this.year !== year) {
        this.year = year;
        this.loadList();
      }
    },

    onChangeChartType(type) {
      this.chartType = type;
      this.loadList();
    },

    onBackClick() {
      this.$router.push({ name: 'project-graph' })
    },

    onClickExcelDownload () {
      this.excelDownFunc(this.tableListAll)
    },

    excelDownFunc(convertList) {
      // 엑셀 워크시트로 json 내보내기
      // 배열만 가능
      const dataWS = XLSX.utils.json_to_sheet(convertList);
      // 엑셀의 workbook을 만든다
      // workbook은 엑셀파일에 지정된 이름이다.
      const wb = XLSX.utils.book_new();
      // workbook에 워크시트 추가
      // 시트명은 'nameData'
      XLSX.utils.book_append_sheet(wb, dataWS, "위험성평가 현황");
      // 엑셀 파일을 내보낸다.

      const chartType = this.chartType === 'all' ? '전체' : this.chartType
      XLSX.writeFile(wb, `위험성평가 현황_${this.year}_${chartType}.xlsx`);
    },
  },

}
</script>

<style lang="scss" scoped>
.btn-border {
  font-size: 12px;
  min-width: 55px;
  border-radius: 999px;
  display: inline-block;
  text-align: center;
  cursor: pointer;

  border: 1px solid #cdcdcd;
  font-weight: 500;

  &.active {
    background-color: #6670cb;
    color: white;
  }
}
</style>
